import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { consultantIdentity } from '../../data/consultant';
import { usePrefersReducedMotion } from '../../hooks/useMedia';
type Props = {
  open: boolean;
  /** Shows a quiet dot when the consultant has an unread opening message. */
  unread: boolean;
  onClick: () => void;
};

/** Floating Morvix AI entry point — anchored to the middle-left edge. */
export function ConsultantLauncher({
  open,
  unread,
  onClick
}: Props) {
  const reduced = usePrefersReducedMotion();
  return <div className="pointer-events-none fixed left-0 top-1/2 z-[75] -translate-y-1/2" data-id="element-73" data-mp="6tvukinakvca">
      <motion.button type="button" onClick={onClick} aria-expanded={open} aria-label={`${open ? 'Close' : 'Open'} ${consultantIdentity.name}, your ${consultantIdentity.role}`} className="pointer-events-auto group flex flex-col items-center gap-3 rounded-r-2xl border border-l-0 border-line bg-surface2/85 px-2.5 py-4 text-ink backdrop-blur-xl transition-colors hover:border-brand" style={{
      boxShadow: '0 18px 50px -22px rgb(5 17 242 / 0.5)'
    }} initial={reduced ? {
      opacity: 0
    } : {
      opacity: 0,
      x: -28
    }} animate={reduced ? {
      opacity: 1
    } : {
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.6,
      delay: 1.1,
      ease: [0.16, 1, 0.3, 1]
    }} whileHover={reduced ? undefined : {
      x: 3
    }} data-cursor="label" data-cursor-label={open ? 'Close' : 'Ask Morvix AI'} data-id="element-74" data-mp="3p5ikw93yjm7f">
        <span className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-brand text-white" data-id="element-75" data-mp="2jf4gbgtcncv0">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-76" data-mp="2xd1f8jv9zvcu" />
          {!reduced ? <motion.span className="absolute inset-0 rounded-xl" style={{
          border: '1px solid rgb(5 17 242 / 0.6)'
        }} animate={{
          opacity: [0.7, 0, 0.7],
          scale: [1, 1.45, 1]
        }} transition={{
          duration: 2.8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} aria-hidden="true" data-id="element-77" data-mp="2serii4twkmp4" /> : null}
          {unread && !open ? <span className="absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full bg-lav ring-2 ring-surface2" aria-hidden="true" data-id="element-78" data-mp="331j86mxjybqb" /> : null}
        </span>
        <span className="label hidden text-muted transition-colors group-hover:text-brand sm:block" style={{
        writingMode: 'vertical-rl'
      }} data-id="element-79" data-mp="383s4nt9mvvx6">
          Morvix AI
        </span>
      </motion.button>
    </div>;
}